import React from "react";

import moment from "moment";

const CommunityCommentExample = ({ comment }) => {
	return (
		<div className={`community-comment-example`} key={`comment-${comment?.id}`}>
			<img
				src={`${
					comment?.is_influencer
						? `${process.env.REACT_APP_S3_HOST}/image/together/profile_${comment?.created_by}.${comment?.influencer_profile_img_type}`
						: comment?.profile_img_type
						? `${process.env.REACT_APP_S3_HOST}/image/together/channel_user/profile/${comment?.created_by}.${comment?.profile_img_type}`
						: `/assets/images/channel/basic.png`
				}`}
				alt={`댓글 프로필 이미지`}
				onError={({ currentTarget }) => {
					currentTarget.onerror = null; // prevents looping
					// currentTarget.style.display = "none";
					currentTarget.src = `/assets/images/channel/basic.png`;
				}}
				className={`comment-img`}
				style={{
					borderRadius: "50%",
				}}
			/>
			<div className={`comment-example-body`}>
				<div className={`comment-example-name`}>
					<p className={`bold`}>{comment?.created_by_name}</p>
					<p
						className={`gray`}
						style={{
							marginLeft: "auto",
						}}
					>
						{moment(moment(comment?.created_at), "YYYY.MM.DD").fromNow()}
					</p>
				</div>
				{comment?.is_secret ? (
					<>
						{comment?.is_mine && comment?.content?.length ? (
							<p className={`gray content`}>{comment?.content}</p>
						) : (
							<p className={`gray content`}>비밀 댓글입니다</p>
						)}
					</>
				) : (
					<p className={`gray content`}>{comment?.content}</p>
				)}
			</div>
		</div>
	);
};
export default CommunityCommentExample;
